const parsed = Number(import.meta.env.VITE_REALITY_ID);

/** Falls back to 1 when env is missing or invalid (avoids `blacklist?realityId=NaN` and empty lists). */
export const realityId =
  Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : 1;
